import React from 'react';
import useRegister from './useRegister';
import './style.scss';

export default function FormRegister() {
  const {
    form,
    handlerChooseOption,
    formError,
    handlerForm,
    checkInputs,
    isSuccess,
    isDisabledBtn,
    handlerFormRegister,
  } = useRegister();
  console.log(isDisabledBtn);
  console.log(formError);
  console.log(form);
  return (
    <div className='main_content shop pb-80'>
      <div className='container'>
        <div className='row justify-content-center'>
          <div className='col-xl-6 col-md-10'>
            <div className='login_wrap widget-taber-content p-30 background-white border-radius-5'>
              <div className='padding_eight_all bg-white'>
                <div className='heading_s1'>
                  <h3 className='mb-30'>Đăng ký tài khoản</h3>
                  <ul className='register_select nav flex mb-20'>
                    <li>
                      <div className='form-check'>
                        <input
                          className='form-check-input'
                          type='radio'
                          name='type-register'
                          checked={form.is_company === 0}
                          onClick={() => {
                            handlerChooseOption(0);
                          }}
                          id='person'
                        />
                        <label className='form-check-label' for='person'>
                          Cá nhân
                        </label>
                      </div>
                    </li>
                    <li>
                      <div className='form-check ml-10'>
                        <input
                          className='form-check-input'
                          type='radio'
                          name='type-register'
                          checked={form.is_company === 1}
                          onClick={() => {
                            handlerChooseOption(1);
                          }}
                          id='company'
                        />
                        <label className='form-check-label' for='company'>
                          Doanh nghiệp
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
                <form
                  onSubmit={(e) => {
                    handlerFormRegister(e);
                  }}
                >
                  {form.is_company === 0 ? (
                    <div className='form-group'>
                      <label>Họ và tên</label>
                      <input
                        type='text'
                        required=''
                        className='form-control'
                        name='fullname'
                        placeholder=''
                        value={form.full_name || ''}
                        style={
                          formError.full_name?.isError === 1
                            ? {
                                borderColor: '#ff3333',
                              }
                            : {}
                        }
                        onChange={(e) => {
                          handlerForm(e.target.value, 'full_name');
                          checkInputs(
                            e.target.value,
                            ['required'],
                            'full_name',
                            'Họ và tên'
                          );
                        }}
                        onBlur={(e) => {
                          checkInputs(
                            e.target.value,
                            ['required'],
                            'full_name',
                            'Họ và tên'
                          );
                        }}
                      />
                      {formError.full_name &&
                      formError.full_name?.isError === 1 ? (
                        <small className='text-danger p-1'>
                          {formError.full_name?.message}
                        </small>
                      ) : (
                        ''
                      )}
                    </div>
                  ) : (
                    <>
                      <div className='form-group'>
                        <label>Tên doanh nghiệp</label>
                        <input
                          type='text'
                          required=''
                          className='form-control'
                          name='fullname'
                          placeholder=''
                          style={
                            formError.company?.isError === 1
                              ? {
                                  borderColor: '#ff3333',
                                }
                              : {}
                          }
                          value={form.company || ''}
                          onChange={(e) => {
                            handlerForm(e.target.value, 'company');
                            checkInputs(
                              e.target.value,
                              ['required'],
                              'company',
                              'Tên doanh nghiệp'
                            );
                          }}
                          onBlur={(e) => {
                            checkInputs(
                              e.target.value,
                              ['required'],
                              'company',
                              'Tên doanh nghiệp'
                            );
                          }}
                        />
                        {formError.company &&
                        formError.company?.isError === 1 ? (
                          <small className='text-danger p-1'>
                            {formError.company?.message}
                          </small>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className='form-group'>
                        <label>Mã số thuế</label>
                        <input
                          type='text'
                          className='form-control'
                          name='tax_code'
                          placeholder=''
                          required
                          style={
                            formError.tax_code?.isError === 1
                              ? {
                                  borderColor: '#ff3333',
                                }
                              : {}
                          }
                          value={form.tax_code || ''}
                          onBlur={(e) => {
                            checkInputs(
                              e.target.value,
                              ['required'],
                              'tax_code',
                              'Mã số thuế'
                            );
                          }}
                          onChange={(e) => {
                            handlerForm(e.target.value, 'tax_code');
                            checkInputs(
                              e.target.value,
                              ['required'],
                              'tax_code',
                              'Mã số thuế'
                            );
                          }}
                        />
                        {formError.tax_code &&
                        formError.tax_code?.isError === 1 ? (
                          <small className='text-danger p-1'>
                            {formError.tax_code?.message}
                          </small>
                        ) : (
                          ''
                        )}
                      </div>
                    </>
                  )}
                  <div className='form-group'>
                    <label>Email</label>
                    <input
                      type='text'
                      required=''
                      className='form-control'
                      name='email'
                      placeholder=''
                      value={form.email || ''}
                      style={
                        formError.email?.isError === 1
                          ? {
                              borderColor: '#ff3333',
                            }
                          : {}
                      }
                      onChange={(e) => {
                        handlerForm(e.target.value, 'email');
                        checkInputs(
                          e.target.value,
                          ['required', 'email'],
                          'email',
                          'Email'
                        );
                      }}
                      onBlur={(e) => {
                        checkInputs(
                          e.target.value,
                          ['required', 'email'],
                          'email',
                          'Email'
                        );
                      }}
                    />
                    {formError.email && formError.email?.isError === 1 ? (
                      <small className='text-danger p-1'>
                        {formError.email?.message}
                      </small>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group'>
                    <label>Số điện thoại</label>
                    <input
                      className='form-control'
                      required=''
                      type='phone_number'
                      name='phone_number'
                      placeholder=''
                      value={form.phone_number || ''}
                      style={
                        formError.phone_number?.isError === 1
                          ? {
                              borderColor: '#ff3333',
                            }
                          : {}
                      }
                      onChange={(e) => {
                        handlerForm(e.target.value, 'phone_number');
                        checkInputs(
                          e.target.value,
                          ['required', 'phone_number'],
                          'phone_number',
                          'Số điện thoại'
                        );
                      }}
                      onBlur={(e) => {
                        checkInputs(
                          e.target.value,
                          ['required', 'phone_number'],
                          'phone_number',
                          'Số điện thoại'
                        );
                      }}
                    />
                    {formError.phone_number &&
                    formError.phone_number?.isError === 1 ? (
                      <small className='text-danger p-1'>
                        {formError.phone_number?.message}
                      </small>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group'>
                    <label>Mật khẩu</label>
                    <input
                      className='form-control'
                      required=''
                      type='password'
                      name='password'
                      placeholder=''
                      style={
                        formError.password?.isError === 1
                          ? {
                              borderColor: '#ff3333',
                            }
                          : {}
                      }
                      value={form.password || ''}
                      onChange={(e) => {
                        handlerForm(e.target.value, 'password');
                        checkInputs(
                          e.target.value,
                          ['required', 'min:6'],
                          'password',
                          'Mật khẩu'
                        );
                      }}
                      onBlur={(e) => {
                        checkInputs(
                          e.target.value,
                          ['required', 'min:6'],
                          'password',
                          'Mật khẩu'
                        );
                      }}
                    />
                    {formError.password && formError.password?.isError === 1 ? (
                      <small className='text-danger p-1'>
                        {formError.password?.message}
                      </small>
                    ) : (
                      ''
                    )}
                  </div>
                  <span className='text-danger mb-10 d-block'>
                    {isSuccess === false
                      ? 'Đăng kí không thành công, vui lòng kiểm tra lại thông tin đăng ký.'
                      : ''}
                  </span>
                  <div className='form-group'>
                    <button
                      type='submit'
                      className={`btn btn-fill-out btn-block ${
                        !isDisabledBtn ? 'disable' : ''
                      }`}
                      name='login'
                      disabled={!isDisabledBtn}
                    >
                      Tạo tài khoản
                    </button>
                  </div>
                </form>
                <div className='divider-text-center mt-15 mb-15'>
                  <span> Hoặc</span>
                </div>
                <div className='text-muted text-center'>
                  Đã có tài khoản? <a href='/dang-nhap'>Đăng nhập</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
